import { render } from "./Subtitles.vue?vue&type=template&id=04046f44&scoped=true"
import script from "./Subtitles.vue?vue&type=script&lang=js"
export * from "./Subtitles.vue?vue&type=script&lang=js"

import "./Subtitles.vue?vue&type=style&index=0&id=04046f44&scoped=true&lang=css"

import exportComponent from "G:\\01.Progetti\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04046f44"]])

export default __exports__